import ForgotPasswordView from "@/components/views/Security/ForgotPassword";

export default function Index() {
  return <ForgotPasswordView />;
}
